// CODICI_COMUNI = require('./codiciLocalita.js');
import CODICI_COMUNI from './codiciLocalita.js';

function getLettereNome(nome) {
  nome = nome.toUpperCase().replace(/ /g,'');
  const VOCALI = ['A', 'E', 'I', 'O', 'U', 'Y',"'"];
  let lettereNome = [];
  for (let i = 0; i < nome.length && lettereNome.length < 4; i++) {
    const _char = nome[i];
    if (VOCALI.indexOf(_char) == -1) {
      lettereNome.push(_char);
    }
  }
  if(lettereNome.length == 4){
    lettereNome.splice(1, 1);
  }
  if (lettereNome.length < 3) {
    for (let i = 0; i < nome.length && lettereNome.length < 3; i++) {
      const _char = nome[i];
      if (VOCALI.indexOf(_char) !== -1) {
        lettereNome.push(_char);
      }
    }
  }
  return lettereNome.join('');
}

function getLettereCognome(nome) {
  nome = nome.toUpperCase().replace(/ /g,'');
  const VOCALI = ['A', 'E', 'I', 'O', 'U', 'Y',"'"];
  let lettereNome = [];
  for (let i = 0; i < nome.length && lettereNome.length < 3; i++) {
    const _char = nome[i];
    if (VOCALI.indexOf(_char) == -1) {
      lettereNome.push(_char);
    }
  }
  if (lettereNome.length < 3) {
    for (let i = 0; i < nome.length && lettereNome.length < 3; i++) {
      const _char = nome[i];
      if (VOCALI.indexOf(_char) !== -1) {
        lettereNome.push(_char);
      }
    }
  }
  return lettereNome.join('');
}

function calcoloCodiceFiscale(nome, cognome, dataNascita, luogoNascita, genere) {
  let arrayCF = [];
  const CODICI_MESE = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];

  const _dataNascita = new Date(dataNascita);
  arrayCF.push(getLettereCognome(cognome));
  arrayCF.push(getLettereNome(nome));
  arrayCF.push((_dataNascita.getFullYear() + '').substring(2));
  arrayCF.push(CODICI_MESE[_dataNascita.getMonth()]);
  let giornoNascita = _dataNascita.getDate();
  if (genere == 'F') {
    giornoNascita += 40;
  }
  giornoNascita = (giornoNascita + '').padStart(2, '0');
  arrayCF.push(giornoNascita);
  arrayCF.push(CODICI_COMUNI.find(i => i.localita.toUpperCase() == luogoNascita.toUpperCase()).codice);
  return arrayCF.join('');
}

function getLetteraControllo(partialCF) {
  const CONVERSIONE_DISPARI = [
    { chars: ['0', 'A'], value: 1 },
    { chars: ['1', 'B'], value: 0 },
    { chars: ['2', 'C'], value: 5 },
    { chars: ['3', 'D'], value: 7 },
    { chars: ['4', 'E'], value: 9 },
    { chars: ['5', 'F'], value: 13 },
    { chars: ['6', 'G'], value: 15 },
    { chars: ['7', 'H'], value: 17 },
    { chars: ['8', 'I'], value: 19 },
    { chars: ['9', 'J'], value: 21 },
    { chars: ['K'], value: 2 },
    { chars: ['L'], value: 4 },
    { chars: ['M'], value: 18 },
    { chars: ['N'], value: 20 },
    { chars: ['O'], value: 11 },
    { chars: ['P'], value: 3 },
    { chars: ['Q'], value: 6 },
    { chars: ['R'], value: 8 },
    { chars: ['S'], value: 12 },
    { chars: ['T'], value: 14 },
    { chars: ['U'], value: 16 },
    { chars: ['V'], value: 10 },
    { chars: ['W'], value: 22 },
    { chars: ['X'], value: 25 },
    { chars: ['Y'], value: 24 },
    { chars: ['Z'], value: 23 },
  ];
  const CARATTERI = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  let sommaDispari = 0;
  let sommaPari = 0;
  for (let i = 0; i < partialCF.length; i++) {
    const _char = partialCF[i];
    if (i % 2 != 0) {
      sommaPari += CONVERSIONE_DISPARI.findIndex(item => item.chars.indexOf(_char) != -1);
    } else {
      sommaDispari += (CONVERSIONE_DISPARI.find(item => item.chars.indexOf(_char) != -1).value);
    }
  }
  const result = (sommaPari + sommaDispari) % 26;
  return CARATTERI[result];
}
const partialCF = calcoloCodiceFiscale('Emanuele', 'DOrazi', '1992-07-05', 'Roma', 'M');
const CF = partialCF + getLetteraControllo(partialCF);

function getCoficeFiscale(nome, cognome, dataNascita, luogoNascita, genere){
  const partialCF = calcoloCodiceFiscale(nome, cognome, dataNascita, luogoNascita, genere);
  return partialCF + getLetteraControllo(partialCF);
}

// module.exports=getCoficeFiscale;

// console.log(CF);

export default  getCoficeFiscale;
